import React, { useState } from "react";
import { Box, Button, Dialog, DialogContent, DialogTitle, Grid, Typography } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import Notify from "../../../../Notify";
import TabAltaEnv from "../../../clientesEnvasado/alta/TabAltaEnv";
import AltaDireccionEnv from "../../../clientesEnvasado/fichaCliente/direcciones/AltaDireccionEnv";
import AgregarCoordenadasEnv from "../agregarCoordenadas/AgregarCoordenadasEnv";
import EditarClientePedido from "../edicionCliente/EditarClientePedido";
import DetalleDirecSeleccionada from "../DetalleDirecSeleccionada";
import BuscadorDireccion from "./components/BuscadorDireccion";
import ClienteSeleccionadoCard from "./components/ClienteSeleccionadoCard";
import DatosPedidoForm from "./components/DatosPedidoForm";
import ListaLineasPedido from "./components/ListaLineasPedido";
import { useBusquedaDirecciones } from "./hooks/useBusquedaDirecciones";
import { useSeleccionDireccion } from "./hooks/useSeleccionDireccion";
import { useLineasPedido } from "./hooks/useLineasPedido";
import { useDatosPedido } from "./hooks/useDatosPedido";
import { useGuardarPedido } from "./hooks/useGuardarPedido";
import { useNotificacion } from "./hooks/useNotificacion";

function NuevoPedido(props) {
  const [uuidPedido] = useState(uuidv4);

  // "tabla" = el modal principal está visible. Se oculta mientras está
  // abierto alguno de los sub-modales (alta cliente, dirección, etc.).
  const [tabla, setTabla] = useState(true);
  const [alta, setAlta] = useState(false);
  const [nuevaDireccion, setNuevaDireccion] = useState(false);
  const [editarCliente, setEditarCliente] = useState(false);
  const [abrirCoordenadas, setAbrirCoordenadas] = useState(false);

  const busqueda = useBusquedaDirecciones();

  const {
    direccionSeleccionada,
    clienteSeleccionado,
    pedidoPendDirec,
    agregarCoordenadas,
    handleDireccionSeleccionada,
    limpiarSeleccion,
  } = useSeleccionDireccion({ tabla });

  const lineas = useLineasPedido({
    uuidPedido,
    clienteSeleccionado,
    direccionSeleccionada,
    tabla,
  });

  const { datosPedido, almacenar, pedidoCambio, handlePedidoCambioChange, pedidoParaCambio } =
    useDatosPedido();

  const handleClose = () => {
    props.setOpen(false);
  };

  const { notificacion, notificarError, notificarExito, handleCloseNotificacion } =
    useNotificacion({ onCerrarModal: handleClose });

  const { disabled, guardarPedido, guardadoParcial, idPedidoParcial } = useGuardarPedido({
    uuidPedido,
    clienteSeleccionado,
    direccionSeleccionada,
    datosPedido,
    pedidoParaCambio,
    datosRenglon: lineas.datosRenglon,
    // Al guardar se muestra el aviso y el modal se cierra cuando el aviso se oculta.
    onGuardado: () => notificarExito("Pedido guardado."),
    onError: notificarError,
  });

  const abrirSubModal = (setSubModal) => {
    setSubModal(true);
    setTabla(false);
  };

  const cerrarSubModal = (setSubModal) => {
    setSubModal(false);
    setTabla(true);
  };

  // setOpen que reciben AltaDireccionEnv / EditarClientePedido.
  const setOpenSubModal = (setSubModal) => (value) => {
    if (value === false) {
      cerrarSubModal(setSubModal);
    } else {
      abrirSubModal(setSubModal);
    }
  };

  const handleClickNuevo = () => {
    setAlta(true);
    setTabla(false);
    limpiarSeleccion();
  };

  return (
    <div>
      {tabla ? (
        <Dialog fullWidth open={props.open} onClose={() => props.setOpen(false)} maxWidth="xl">
          {notificacion && notificacion.open ? (
            <Notify
              // Notify toma "open" sólo al montarse: la key lo remonta si cambia el aviso.
              key={notificacion.severity + notificacion.mensaje}
              mensaje={notificacion.mensaje}
              open={notificacion.open}
              color={notificacion.color}
              duracion={notificacion.duracion}
              handleClose={handleCloseNotificacion}
              severity={notificacion.severity}
            />
          ) : null}
          <Box justifyContent="center" backgroundColor="#1F618D">
            <DialogTitle>
              <Typography fontSize={20} align="center" color="#ffffff">
                Nuevo Pedido 
              </Typography>
            </DialogTitle>
          </Box>
          <form>
            <DialogContent>
              {guardadoParcial ? (
                <Box
                  sx={{
                    backgroundColor: "#FADBD8",
                    border: "1px solid",
                    borderColor: "error.main",
                    borderRadius: 1,
                    p: 1,
                    mb: 1,
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  El pedido #{idPedidoParcial} quedó guardado con renglones incompletos.
                  Presione "Guardar" para reintentar los renglones pendientes.
                </Box>
              ) : null}
              {/* Con un guardado parcial el formulario se bloquea: los reintentos
                  envían los datos del primer intento. */}
              <Box
                sx={guardadoParcial ? { pointerEvents: "none", opacity: 0.6 } : undefined}
                aria-disabled={guardadoParcial}
              >
                <Grid container spacing={1}>
                  {pedidoPendDirec && pedidoPendDirec.length > 0 ? (
                    <Grid
                      item
                      xs={12}
                      style={{
                        backgroundColor: "#fff9c4",
                        fontWeight: "bold",
                        textAlign: "center",
                        padding: "8px",
                      }}
                    >
                      <label>
                        Este Cliente Tiene un Pedido Pendiente en esa Dirección, Consulte al
                        Cliente
                      </label>
                    </Grid>
                  ) : null}

                  <BuscadorDireccion
                    filtrosSeleccionados={busqueda.filtrosSeleccionados}
                    onFiltrosChange={busqueda.handleFiltrosChange}
                    inputValue={busqueda.inputValueDirecciones}
                    onInputChange={busqueda.handleInputChange}
                    opciones={busqueda.todasDirecciones}
                    loading={busqueda.loadingDirecciones}
                    placeholder={busqueda.placeholder}
                    value={direccionSeleccionada}
                    onChange={handleDireccionSeleccionada}
                    onClickNuevoCliente={handleClickNuevo}
                    mostrarAgregarCoordenadas={agregarCoordenadas}
                    onClickAgregarCoordenadas={() => abrirSubModal(setAbrirCoordenadas)}
                  />

                  {clienteSeleccionado && (
                    <ClienteSeleccionadoCard
                      clienteSeleccionado={clienteSeleccionado}
                      direccionSeleccionada={direccionSeleccionada}
                      onEditarCliente={() => abrirSubModal(setEditarCliente)}
                      onNuevaDireccion={() => abrirSubModal(setNuevaDireccion)}
                    />
                  )}

                  <Grid item xs={12} mr={3}>
                    {direccionSeleccionada !== "" ? (
                      <DetalleDirecSeleccionada
                        clienteSeleccionado={clienteSeleccionado}
                        direccionSeleccionada={direccionSeleccionada}
                      />
                    ) : null}
                  </Grid>

                  <Grid item xs={12} mr={3}>
                    {direccionSeleccionada ? (
                      <DatosPedidoForm
                        datosPedido={datosPedido}
                        onChange={almacenar}
                        pedidoCambio={pedidoCambio}
                        onPedidoCambioChange={handlePedidoCambioChange}
                      />
                    ) : null}

                    {direccionSeleccionada ? <ListaLineasPedido lineas={lineas} /> : null}
                  </Grid>
                </Grid>
              </Box>

              <Grid container direction="row" justifyContent="space-between" mt={1}>
                <Grid item>
                  <Button
                    color="error"
                    variant="outlined"
                    onClick={() => props.setOpen(false)}
                    style={{ backgroundColor: "#fff" }}
                    size="small"
                  >
                    Volver
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    disabled={disabled}
                    color="success"
                    variant="contained"
                    onClick={guardarPedido}
                    size="small"
                  >
                    Guardar
                  </Button>
                </Grid>
              </Grid>
            </DialogContent>
          </form>
        </Dialog>
      ) : null}

      {alta && (
        <Dialog open={props.open} onClose={() => props.setOpen(false)} fullScreen>
          <TabAltaEnv alta={setAlta} tabla={setTabla} />
        </Dialog>
      )}

      {nuevaDireccion ? (
        <AltaDireccionEnv
          open={nuevaDireccion}
          setOpen={setOpenSubModal(setNuevaDireccion)}
          cliente={clienteSeleccionado}
          onClose={() => cerrarSubModal(setNuevaDireccion)}
        />
      ) : null}

      {editarCliente ? (
        <EditarClientePedido
          open={editarCliente}
          setOpen={setOpenSubModal(setEditarCliente)}
          cliente={clienteSeleccionado}
          onClose={() => cerrarSubModal(setEditarCliente)}
        />
      ) : null}

      {abrirCoordenadas ? (
        <AgregarCoordenadasEnv
          open={abrirCoordenadas}
          setOpen={setAbrirCoordenadas}
          direccionSeleccionada={direccionSeleccionada}
          onClose={() => cerrarSubModal(setAbrirCoordenadas)}
        />
      ) : null}
    </div>
  );
}

export default NuevoPedido;
